import {
    AnyAction,
    createAsyncThunk,
    createSlice,
    PayloadAction,
} from "@reduxjs/toolkit";
import * as Sentry from "@sentry/nextjs";
import { apiCall, parseAPIResponse } from "../../services/api";
import _ from "lodash";
import { SalvationsState } from "./types";
import { ReducerType } from "../rootReducer";
import MainActions from "../main";
import { tokenErrorText } from "../../constants";
import { User } from "../main/types";

const defaultState: SalvationsState = {
    isLoading: false,
    salvationRegisterData: null,
};

const salvations_register_user = createAsyncThunk(
    "salvation/fetchRegisterSalvationUser",
    async (
        params: { userData: User; campusId: string; callback?: Function },
        { getState, dispatch }
    ) => {
        const { main } = getState() as ReducerType;
        let token = undefined;

        if (
            main.userData &&
            main.userData.token &&
            main.userData.token.access_token
        ) {
            token = main.userData.token.access_token;

            if (parseInt(main.userData.token.expires_at) < Date.now()) {
                if (params.callback && _.isFunction(params.callback)) {
                    params.callback(1);
                }

                dispatch(
                    MainActions.actions.main_set_token_error(tokenErrorText)
                );
                return false;
            }
        }

        const dataToSend = new FormData();

        // dataToSend.append('contact_id', contactId);
        dataToSend.append("primary_campus_id", params.campusId);
        dataToSend.append("first_name", params.userData.firstName);
        dataToSend.append("last_name", params.userData.lastName);
        dataToSend.append("phone_number", params.userData.mobileNumber);
        dataToSend.append("email", params.userData.email);
        dataToSend.append("birthdate", params.userData.birthdate);

        return apiCall(
            "/v2/salvation/confirmSalvation",
            "POST",
            dataToSend,
            undefined,
            token
        )
            .then(parseAPIResponse, (error) => {
                Sentry.captureMessage(error);
            })

            .then((data) => {
                if (data && data.data) {
                    if (
                        params.callback &&
                        _.isFunction(params.callback) &&
                        data.status_code === 201
                    ) {
                        params.callback(8); // go to step 8 after it is successful
                    }

                    return data.data;
                } else {
                    return {};
                }
            });
    }
);

const salvationStore = createSlice({
    name: "salvation",
    initialState: defaultState,
    reducers: {
        main_loading(state, action: PayloadAction<boolean>) {
            state.isLoading = action.payload;
        },
    },
    extraReducers: (builder) =>
        builder
            .addCase(salvations_register_user.fulfilled, (state, action) => {
                state.salvationRegisterData = action.payload;
            })
            .addMatcher(
                (action: AnyAction): action is PayloadAction => {
                    return (
                        action.type.endsWith("pending") &&
                        action.type.indexOf("salvation") > -1
                    );
                },
                (state) => {
                    state.isLoading = true;
                }
            )
            .addMatcher(
                (action: AnyAction): action is PayloadAction => {
                    return (
                        action.type.endsWith("rejected") &&
                        action.type.indexOf("salvation") > -1
                    );
                },
                (state) => {
                    state.isLoading = false;
                }
            ),
});

export const actions = {
    salvations_register_user,
    ...salvationStore.actions,
};
export default salvationStore;
